var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{class:[
    'z-icon',
    _vm.strokeClass,
    _vm.getSizeStyle,
    _vm.icon && `z-icon--${_vm.icon}`,
    _vm.position && `${_vm.getPositionStyle}`,
    `text-${_vm.color}`,
    _vm.spinByDefault && 'animate-spin'
  ],attrs:{"viewBox":"0 0 24 24","stroke-linecap":"round","stroke-linejoin":"round","fill":"none"},domProps:{"innerHTML":_vm._s(_vm.iconContent)},on:{"click":_vm.handleClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }